
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import PedidoInterface, { PedidoProduto } from "../../interfaces/Pedido";
import {
  calcular_preco_quantidade_minima,
  calcular_preco_unidade_medida,
  calcular_quantidade_unidade_medida,
} from "../../services/ProdutosService";
import { moneyFormatter } from "../utils";
import Decimal from "decimal.js";

const PedidoStore = namespace("Pedido");

@Component({
  name: "PedidoTotais",
  components: {},
})
export default class PedidoTotais extends Vue {
  @PedidoStore.Getter
  private getPedido!: PedidoInterface;

  // faz a soma do total com base no preco padrão
  get valor_total() {
    const total = this.getPedido?.produtos?.reduce(
      (acc: any, item: PedidoProduto) => {
        // faz o calculo da quantidade de produtos com base na unidade de medida
        const valor_total_unidade_medida = calcular_preco_unidade_medida({
          lista_unidade_medida: item.produto.unidadesMedida,
          preco_unit: +item.produto.precosVenda?.[0]?.precoUnit, // preco unitario padrão do produto
          unidadeMedida: item.unidadeMedida,
          unidadeMedidaPadrao: item.produto.unidadeMedida, // unidade de medida padrão do produto
        });

        const valor_total = valor_total_unidade_medida * +item.quantidade;

        return acc + valor_total;
      },
      0
    );

    return total || 0;
  }

  // faz a subtração do total com base no preço padrão e no desconto
  get valor_desconto(){
    const preco_desconto = new Decimal(this.valor_total).minus(this.getSubtotal).toNumber();
    return preco_desconto > 0 ? preco_desconto : 0;
  }

  // faz a soma do total com base no preço padrão e no desconto
  get getSubtotal() {
    const total = this.getPedido?.produtos?.reduce(
      (acc: any, item: PedidoProduto) => {
        // faz o calculo da quantidade de produtos com base na unidade de medida
        const quantidade_produtos = calcular_quantidade_unidade_medida({
          lista_unidade_medida: item.produto.unidadesMedida,
          quantidade: +item.quantidade,
          unidadeMedida: item.unidadeMedida,
          unidadeMedidaPadrao: item.produto.unidadeMedida,
        });

        // faz o calculo do preço unitário com base no desconto de quantidade mínima
        const preco_unit = calcular_preco_quantidade_minima({
          lista_descontos: item.produto.descQtdeMin,
          preco_unit:
            +item.produto.promocao?.[0]?.precoUnit ||
            +item.produto.precosVenda?.[0]?.precoUnit,
          quantidade: quantidade_produtos,
        });

        // faz o calculo do preço unitário do produto com base na unidade de medida
        const valor_total_unidade_medida = calcular_preco_unidade_medida({
          lista_unidade_medida: item.produto.unidadesMedida,
          preco_unit: +preco_unit,
          unidadeMedida: item.unidadeMedida,
          unidadeMedidaPadrao: item.produto.unidadeMedida,
        });

        const valor_total = valor_total_unidade_medida * +item.quantidade;

        return acc + valor_total;
      },
      0
    );

    return this.getPedido.valorTotal;
  }

  moneyFormatter(value: number) {
    return moneyFormatter(value);
  }
}
